export enum PageCtaEnum {
  BOOKING_CALENDAR = "booking_calendar",
  CUSTOM = "custom",
  NONE = "none",
}
